require('../../../node_modules/gsap/ScrollToPlugin');


export class backToTop {
    constructor() {
        this.backToTop = null;
        this.height = null;
        this.el = document.getElementById('scrollTo');
        this.init();
        this.tl = new TimelineMax();
    }

    init() {
        this.listen();
        this.click();
    }

    listen() {
        this.backToTop = this.el.offsetHeight;
        let h = window.innerHeight;


        window.addEventListener('scroll', this.throttle((e) => {
            let calculCase = h - window.pageYOffset;
            if (calculCase < 100) {
                this.tl.set(this.el, {className:"+=active"});
            } else {
                this.tl.set(this.el, {
                    className:"-=active", onComplete: () => {
                    }
                });
            }
        }), 60);
    }

    click() {
        this.el.addEventListener('click', () => {
            TweenLite.to(window, 2, {scrollTo:{y:0, autoKill:false}, ease: Power4.easeInOut,});

        });
    }

    throttle(callback, delay) {
        var last;
        var timer;
        return function () {
            var context = this;
            var now = +new Date();
            var args = arguments;
            if (last && now < last + delay) {
                // le délai n'est pas écoulé on reset le timer
                clearTimeout(timer);
                timer = setTimeout(function () {
                    last = now;
                    callback.apply(context, args);
                }, delay);
            } else {
                last = now;
                callback.apply(context, args);
            }
        };
    }


}
